import { doc, setDoc, collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { dbLOA, storage } from "../../../../backend/firebaseconfig";

const safeEmail = (email = "") => email.trim().toLowerCase();

const getIsoNow = () => new Date().toISOString();

const getCounts = (answers = []) => {
  return answers.reduce(
    (acc, row) => {
      const status = row.status || "missing";
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    },
    { found: 0, partial: 0, missing: 0 },
  );
};

// export const saveCedingSchemeExtraction = async ({
//   userEmail,
//   file = null,
//   files = null,
//   extractionResult,
//   notes = "",
//   extractionId = null,
// }) => {
//   const email = safeEmail(userEmail);

//   if (!email) throw new Error("User email is missing.");
//   if (!extractionResult) throw new Error("Extraction result is missing.");

//   const nowIso = getIsoNow();

//   const baseDocRef = doc(dbLOA, "Ceding Schemes", email);

//   await setDoc(
//     baseDocRef,
//     {
//       userEmail: email,
//       createdBy: email,
//       updatedAt: nowIso,
//       ...(extractionId ? {} : { createdAt: nowIso }),
//     },
//     { merge: true },
//   );

//   const extractionRef = extractionId
//     ? doc(baseDocRef, "Extractions", extractionId)
//     : doc(collection(baseDocRef, "Extractions"));

//   const finalExtractionId = extractionRef.id;

//   const filesToUpload =
//     Array.isArray(files) && files.length ? files : file ? [file] : [];

//   let uploadedFiles = [];

//   if (filesToUpload.length > 0) {
//     uploadedFiles = await Promise.all(
//       filesToUpload.map(async (selectedFile) => {
//         const storagePath = `Ceding Schemes/${email}/Extractions/${finalExtractionId}/${selectedFile.name}`;
//         const fileRef = ref(storage, storagePath);

//         await uploadBytes(fileRef, selectedFile);

//         const fileUrl = await getDownloadURL(fileRef);

//         return {
//           fileName: selectedFile.name,
//           fileUrl,
//           storagePath,
//           size: selectedFile.size || null,
//         };
//       }),
//     );
//   }

//   const answers = extractionResult?.answers || [];
//   const counts = getCounts(answers);

//   const payload = {
//     id: finalExtractionId,
//     extractionJson: extractionResult,
//     summary: extractionResult?.summary || {},
//     counts,
//     notes,
//     createdBy: email,
//     updatedAt: nowIso,
//     ...(uploadedFiles.length > 0
//       ? {
//           files: uploadedFiles,
//           fileName: uploadedFiles[0].fileName,
//           fileUrl: uploadedFiles[0].fileUrl,
//           storagePath: uploadedFiles[0].storagePath,
//         }
//       : {}),
//     ...(extractionId ? {} : { createdAt: nowIso }),
//   };

//   await setDoc(extractionRef, payload, { merge: true });

//   return {
//     ...payload,
//     extractionId: finalExtractionId,
//   };
// };

export const saveCedingSchemeCaseExtraction = async ({
  userEmail,
  extractionId = null,
  schemes = [],
}) => {
  const email = safeEmail(userEmail);

  if (!email) throw new Error("User email is missing.");
  if (!Array.isArray(schemes) || !schemes.length) {
    throw new Error("Schemes are missing.");
  }

  const nowIso = getIsoNow();

  const baseDocRef = doc(dbLOA, "Ceding Schemes", email);

  await setDoc(
    baseDocRef,
    {
      userEmail: email,
      createdBy: email,
      updatedAt: nowIso,
      ...(extractionId ? {} : { createdAt: nowIso }),
    },
    { merge: true },
  );

  const extractionRef = extractionId
    ? doc(baseDocRef, "Extractions", extractionId)
    : doc(collection(baseDocRef, "Extractions"));

  const finalExtractionId = extractionRef.id;

  const savedSchemes = [];

  for (const scheme of schemes) {
    const uploadedFiles = [];

    for (const selectedFile of scheme.files || []) {
      const storagePath = `Ceding Schemes/${email}/Extractions/${finalExtractionId}/Schemes/${scheme.id}/${selectedFile.name}`;
      const fileRef = ref(storage, storagePath);

      await uploadBytes(fileRef, selectedFile);

      const fileUrl = await getDownloadURL(fileRef);

      uploadedFiles.push({
        fileName: selectedFile.name,
        fileUrl,
        storagePath,
        size: selectedFile.size || null,
      });
    }

    const answers = scheme.extractionJson?.answers || [];
    const counts = getCounts(answers);

    savedSchemes.push({
      id: scheme.id,
      name: scheme.name,
      extractionJson: scheme.extractionJson,
      summary: scheme.extractionJson?.summary || {},
      counts,
      notes: scheme.notes || "",
      files: uploadedFiles.length ? uploadedFiles : scheme.savedFiles || [],
      savedFiles: uploadedFiles.length
        ? uploadedFiles
        : scheme.savedFiles || [],
      updatedAt: nowIso,
    });
  }

  const payload = {
    id: finalExtractionId,
    schemes: savedSchemes,
    schemeCount: savedSchemes.length,
    createdBy: email,
    updatedAt: nowIso,
    updatedAtMs: Date.now(),
    ...(extractionId ? {} : { createdAt: nowIso, createdAtMs: Date.now() }),
  };

  await setDoc(extractionRef, payload, { merge: true });

  return {
    ...payload,
    extractionId: finalExtractionId,
  };
};